import { Delete as DeleteIcon } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";

type DeleteButtonProps = Omit<
  ButtonProps,
  "variant" | "color" | "startIcon" | "type" | "disableElevation"
> & {
  children?: React.ReactNode;
};

export const DeleteButton = (props: DeleteButtonProps) => {
  const { onClick, children, ...others } = props;

  return (
    <Button
      type="button"
      onClick={onClick}
      variant="contained"
      color="error"
      disableElevation
      startIcon={<DeleteIcon />}
      {...others}
    >
      {children}
    </Button>
  );
};
